import {z} from 'zod';

import {isNil} from 'ramda';

import {VehicleFinancingTemplateExpirationActionSchema} from '@dms/api/sales';
import i18n from '@dms/i18n';

export const archiveFormSchema = z
  .object({
    action: VehicleFinancingTemplateExpirationActionSchema,
    replacementTemplateId: z.string().nullable(),
  })
  .superRefine((values, context) => {
    if (values.action === 'REPLACE' && isNil(values.replacementTemplateId)) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.errors.mixed.required'),
        path: ['replacementTemplateId'],
      });
    }
  });

export type ArchiveFormValues = z.infer<typeof archiveFormSchema>;
